import React, { forwardRef } from 'react';

function SvgVercel(props, svgRef) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 16 16"
            width="1em"
            height="1em"
            ref={svgRef}
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7.21786 0.0188027C5.66855 0.18285 4.19834 0.786479 2.98041 1.7586C2.48553 2.17831 2.03207 2.6446 1.6263 3.15106C0.802637 4.24511 0.267094 5.5288 0.0689132 6.88411C-0.00294535 7.48107 -0.0186506 8.08346 0.0220041 8.68335C0.182814 10.489 0.948628 12.1873 2.19521 13.5028C3.44179 14.8183 5.09601 15.6738 6.8895 15.9304C7.34921 15.9992 8.22797 16.0212 8.68768 15.9773C10.4923 15.8164 12.1896 15.0502 13.5043 13.8029C14.819 12.5555 15.6739 10.9003 15.9305 9.10578C15.9993 8.6458 16.0211 7.76652 15.9774 7.30654C15.8394 5.72042 15.2318 4.21151 14.2323 2.9727C13.8129 2.47753 13.3469 2.02381 12.8407 1.61779C11.7467 0.794691 10.464 0.258947 9.10986 0.0594814C8.48116 -0.00244247 7.84864 -0.0160419 7.21786 0.0188027V0.0188027ZM10.0637 7.37225L12.0339 10.8268L8.08725 10.8362C5.91692 10.8393 4.1375 10.8362 4.13124 10.8299C4.12499 10.8237 5.00688 9.25911 6.09517 7.3566C6.75037 6.20226 7.41232 5.05176 8.08099 3.90518L10.0637 7.37225Z"
                clipRule="evenodd"
            />
        </svg>
    );
}

const ForwardRef = forwardRef(SvgVercel);
export default ForwardRef;
